module.exports = __webpack_public_path__ + "static/media/logo_main.5f9ab901.png";